import React, { useState, useEffect } from "react";
import { FaPlus, FaSave, FaEdit, FaTrash } from "react-icons/fa";
import Dialog from "../../../FormDialog/Dialog";

import EnabledDropdown from '../../../../DropDowns/EnabledDropdown/EnabledDropdown';
import CompanyDropdown from "../../../../DropDowns/CompanyDropdown/CompanyDropdown"; 
import { getHeaders } from "../../../../ApiHeaders/apiHeadersEntitlements";
import RolesSelector from "../../../../SearchableList/RolesSearchableList";
import { AMP_USER_TENANT_TYPE } from "../../../constants/entitlementDomains";







interface UsersFormProps {
  selectedUser?: any;
  users: any[];
  onCreateUser: (payload: any) => void;
  onUpdateUser: (id: number, payload: any) => void;
  onDeleteUser: (id: number, loginName: string) => void;
  onDirtyChange: (dirty: boolean) => void;
  onModeChange: (mode: "create" | "edit" | "view" | null) => void;
  onClearSelection: () => void;
  entityType: "USER" | "SERVICE_PRINCIPAL";
  onEntityTypeChange: (type: "USER" | "SERVICE_PRINCIPAL") => void;
  generatedSecret: string | null;
  setGeneratedSecret: (s: string | null) => void;
  companies: any[];
  environment: "DEV" | "STAGE" | "PROD";
  roles: any[];
  selectedRoles: number[];
  onRolesChange: (roles: number[]) => void;
  assetsForUser: string[];
  foldersForUser: string[];
  canDelete?: boolean;
  onRevokeServicePrincipal?: (entraObjectId: string) => void;
}

const UsersForm: React.FC<UsersFormProps> = ({
  selectedUser,
  users,
  onCreateUser,
  onUpdateUser,
  onDeleteUser,
  onDirtyChange,
  onModeChange,
  onClearSelection,
  entityType,
  onEntityTypeChange,
  generatedSecret,
  setGeneratedSecret,
  companies,
  environment,
  roles,
  selectedRoles,
  onRolesChange,
  assetsForUser,
  foldersForUser,
  canDelete = false,
  onRevokeServicePrincipal,
}) => {
  const [loginName, setLoginName] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [enabled, setEnabled] = useState("");
  const [accessGroup, setAccessGroup] = useState("");

  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [userId, setUserId] = useState<number | null>(null);
  const [activeField, setActiveField] = useState<string | null>(null);
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>(
    {}
  );
  const isCreateMode = !isViewMode && !isEditMode;

  const [companyName, setCompanyName] = useState<string>("");

  

  const [dialog, setDialog] = useState<any>({ open: false });
  const closeDialog = () => setDialog({ open: false });

  const [formErrors, setFormErrors] = useState<Record<string, string>>({});

  const [companyId, setCompanyId] = useState<string>("");
  const [clientId, setClientId] = useState<string>("");

  const [entraObjectId, setEntraObjectId] = useState("");

const [clientSecret, setClientSecret] = useState<string | null>(null);
const [copied, setCopied] = useState(false);

// const [userCreationMode, setUserCreationMode] = useState<"NEW" | "EXISTING">("NEW");











useEffect(() => {
  setClientSecret(generatedSecret || null);
}, [generatedSecret]);






  //  Load selected user
  useEffect(() => {
    if (selectedUser && !isEditMode) {
      // setClientSecret(null);

      const company = companies.find(c => c.company_id === selectedUser.company_id);
      setCompanyName(company?.company_name || "");

      setUserId(selectedUser.user_id);
      setLoginName(selectedUser.login_name || "");
      setEmail(selectedUser.email || "");
      setFirstName(selectedUser.first_name || "");
      setLastName(selectedUser.last_name || "");
      setEnabled(selectedUser.enabled || "");
      setAccessGroup(selectedUser.default_access_group || "");
      setEntraObjectId(selectedUser.entra_object_id || "");
      setCompanyId(String(selectedUser.company_id ?? ""));
      setClientId(selectedUser.client_id || "");
      setIsViewMode(true);
      onDirtyChange(false);
    }
  }, [selectedUser]);

  const resetForm = () => {
    setLoginName("");
    setEmail("");
    setFirstName("");
    setLastName("");
    setEnabled("");
    setAccessGroup("");
    setClientSecret("");
    setIsEditMode(false);
    setIsViewMode(false);
    onDirtyChange(false);
    onModeChange(null);
    setModifiedFields({});
    setFormErrors({});

    setUserId(null);
    setEntraObjectId("");
    setCompanyId("");
    setClientId("");
    setCompanyName?.(""); // if you added this state
    setClientSecret(null);
  };

  const handleEdit = () => {
    setIsEditMode(true);
    onDirtyChange(true);
    onModeChange("edit");
  };

  const handleNew = () => {
    setGeneratedSecret(null);

    resetForm();
    onClearSelection();
    onModeChange("create");
  
    onDirtyChange(false);
    onModeChange(null);  
  };
  
  
  

  const handleDelete = () => {
    if (!userId) return;
    setDialog({
      open: true,
      title: "Delete User?",
      message: `Are you sure you want to delete "${loginName}"?`,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        onDeleteUser(userId, loginName);
        closeDialog();
      },
      onCancel: closeDialog,
    });
  };


  const handleSubmit = () => {
    // Validate required fields before submitting
    if (isCreateMode) {
      const errors: Record<string, string> = {};
      if (entityType === "SERVICE_PRINCIPAL") {
        if (!loginName.trim()) errors.loginName = "Client name is required.";
        if (!companyId) errors.companyId = "Company is required.";
      } else {
        if (!email.trim()) errors.email = "Email is required.";
        if (!companyId) errors.companyId = "Company is required.";
        if (!firstName.trim()) errors.firstName = "First name is required.";
        if (!lastName.trim()) errors.lastName = "Last name is required.";
      }
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
    }
    setFormErrors({});

    if (isEditMode && userId) {
      const updatePayload: any = {
        login_name: loginName,
        email,
        first_name: firstName,
        last_name: lastName,
        enabled,
        company_id: Number(companyId) || 0,
        entra_object_id: entraObjectId,
        is_service_principal: entityType === "SERVICE_PRINCIPAL" ? "Y" : "N",
      };

      if (entityType === "SERVICE_PRINCIPAL") {
        updatePayload.client_id = clientId;
      }
  
      onUpdateUser(userId, updatePayload);
      // resetForm();
      // onClearSelection();
      setIsEditMode(false);
      setIsViewMode(true);
      onDirtyChange(false);
      onModeChange("view");
   
  } else {
    // SERVICE PRINCIPAL CREATION
    if (entityType === "SERVICE_PRINCIPAL") {
      const spPayload = {
        client_name: loginName,  // UI field reused
        client_id: clientId,
        company_id: Number(companyId) || 0,
        enabled: enabled || "Y",
      };
    
      onCreateUser({ type: "SERVICE_PRINCIPAL", data: spPayload });
    }
    
  
    //  NORMAL USER CREATION
    else {
      const userPayload = {
        invitedUserDisplayName: [firstName, lastName].filter(Boolean).join(" "),
        invitedUserEmailAddress: email,
        first_name: firstName,
        last_name: lastName,
        company_id: Number(companyId) || 0,
        enabled,
        tenant_type: AMP_USER_TENANT_TYPE,
      };

      onCreateUser({ type: "USER", data: userPayload });
      resetForm();
      onClearSelection();
    }
    // else {

    //   // EXISTING USER (DB ONLY)
    //   if (userCreationMode === "EXISTING") {
    
    //     const existingUserPayload = {
    //       login_name: loginName,
    //       company_id: Number(companyId) || 0,
    //       entra_object_id: entraObjectId,
    //       email,
    //       first_name: firstName,
    //       last_name: lastName,
    //       enabled,
    //       is_service_principal: "N",
    //     };
    
    //     onCreateUser({
    //       type: "EXISTING_USER",
    //       data: existingUserPayload,
    //     });
    
    //   }
    
    //   // NEW USER (AZURE + DB)
    //   else {
    
    //     const userPayload = {
    //       invitedUserDisplayName: loginName,
    //       invitedUserEmailAddress: email,
    //       first_name: firstName,
    //       last_name: lastName,
    //       company_id: Number(companyId) || 0,
    //       enabled,
    //     };
    
    //     onCreateUser({
    //       type: "USER",
    //       data: userPayload,
    //     });
    
    //   }
    
    // }
  }
  
  
    // resetForm();
    // onClearSelection();
  };

 
  

  const handleGenerateSecret = async () => {
    if (!entraObjectId) return;
  
    try {
      const headers = await getHeaders();
  
      const response = await fetch(
        `${process.env.REACT_APP_ENTITLEMENTS_API}/user/service_principal/${entraObjectId}/regenerate_secret`,
        { method: "POST", headers }
      );
  
      const data = await response.json();
      const secret = data?.response?.data?.client_secret;
  
      if (secret) {
        setClientSecret(secret);
        setCopied(false);
      }
  
      setDialog({
        open: true,
        title: "Secret Generated",
        message: "New secret has been generated successfully.",
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
    } catch {
      setDialog({
        open: true,
        title: "Error",
        message: "Failed to generate secret.",
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
    }
  };

  const handleCopySecret = () => {
    if (!clientSecret) return;
    navigator.clipboard.writeText(clientSecret);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleRevoke = () => {
    if (!entraObjectId) return;
    setDialog({
      open: true,
      title: "Revoke Service Principal Access?",
      message:
        "This will immediately disable the service principal and remove all client secrets. This action cannot be undone via the API. Continue?",
      confirmButtonText: "Revoke",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        closeDialog();
        onRevokeServicePrincipal?.(entraObjectId);
      },
      onCancel: closeDialog,
    });
  };
  
  
  const revertToViewMode = () => {
    if (!selectedUser) return;
  
    setLoginName(selectedUser.login_name || "");
    setEmail(selectedUser.email || "");
    setFirstName(selectedUser.first_name || "");
    setLastName(selectedUser.last_name || "");
    setEnabled(selectedUser.enabled || "");
    setAccessGroup(selectedUser.default_access_group || "");
    setEntraObjectId(selectedUser.entra_object_id || "");
    setCompanyId(String(selectedUser.company_id ?? ""));
    setClientId(selectedUser.client_id || "");
  
    setIsEditMode(false);
    setIsViewMode(true);
    onDirtyChange(false);
    onModeChange("view");
  };
  

  const handleEntityToggle = () => {
    setGeneratedSecret(null);
  
    const nextType =
      entityType === "USER" ? "SERVICE_PRINCIPAL" : "USER";
  
    const switchForm = () => {
      resetForm();
      onClearSelection();
      onEntityTypeChange(nextType);
      onModeChange(null);
    };
  
    const isDirty =
      isEditMode ||
      (isCreateMode && Object.keys(modifiedFields).length > 0);
  
    if (isDirty) {
      setDialog({
        open: true,
        title: "Unsaved Changes",
        message:
          "You have unsaved changes. Switching will discard them. Continue?",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          switchForm();
          closeDialog();
        },
        onCancel: closeDialog,
      });
    } else {
      switchForm();
    }
  };

  useEffect(() => {
    if (!selectedUser) {
      resetForm();
    }
  }, [selectedUser]);
  
  

  return (
    <div className="bg-white p-6 rounded-lg shadow-md font-poppins flex flex-col">
      {dialog.open && <Dialog {...dialog} onClose={closeDialog} />}

      <div className="flex justify-between items-center mb-4">

        {/* {entityType === "USER" ? (
          !isViewMode ? (
            <button
              type="button"
              onClick={() =>
                setUserCreationMode(userCreationMode === "NEW" ? "EXISTING" : "NEW")
              }
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
              {userCreationMode === "NEW" ? "Existing User" : "New User"}
            </button>
          ) : (
            <div className="w-[140px]" />
          )
        ) : (
          <div className="w-[140px]" />
        )} */}

        <button
            type="button"
            // onClick={() =>
            //   onEntityTypeChange(entityType === "USER" ? "SERVICE_PRINCIPAL" : "USER")
            // }
            onClick={handleEntityToggle}
            className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
          >
            {entityType === "USER" ? "Service Principal" : "User"}
        </button>

        <div className="flex gap-4">

        {!isViewMode && !isEditMode && (
            <button
            onClick={handleSubmit}
            className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
            <FaPlus className="w-4 h-4" />
            Create
            </button>
        )}

        {isViewMode && !isEditMode && (
          <>
            <button
              onClick={handleNew}
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
              <FaPlus className="w-4 h-4" />
              New
            </button>

            {(entityType === "USER" || entityType === "SERVICE_PRINCIPAL") && (
              <button
                onClick={handleEdit}
                className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
              >
                <FaEdit className="w-4 h-4" />
                Edit
              </button>
            )}

            {/* <button
              onClick={handleDelete}
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
              <FaTrash className="w-4 h-4" />
              Delete
            </button> */}
          </>
        )}


        {/* {isEditMode && entityType === "USER" && (
          <>
            <button
              onClick={handleSubmit}
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
              <FaSave className="w-4 h-4" />
              Save
            </button>

            <button
              // onClick={resetForm}
              onClick={revertToViewMode}
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
              Cancel
            </button>
          </>
        )} */}
        {isEditMode && (entityType === "USER" || entityType === "SERVICE_PRINCIPAL") && (
          <>
            {canDelete && (
              <button
                onClick={handleDelete}
                type="button"
                className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
              >
                <FaTrash className="w-4 h-4" />
                Delete
              </button>
            )}

            <button
              onClick={handleSubmit}
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747]"
            >
              <FaSave className="w-4 h-4" />
              Save
            </button>

            <button
              onClick={revertToViewMode}
              className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747]"
            >
              Cancel
            </button>
          </>
        )}

        {/* </div> */}
        </div>
    </div>



      {/* FORM FIELDS (same UI as UserGroupForm) */}
      <form className="space-y-6 flex-1">
        
        {entityType === "SERVICE_PRINCIPAL" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            
            

            {/*  Company */}
            <div>
              <label className="block text-gray-700 mb-2 font-medium">
                Company<span className="text-red-500 text-lg align-top ml-1">*</span>
              </label>

              <CompanyDropdown
                // selectedCompany={companyId}
                selectedCompany={companyName}
                onCompanyChange={(value: string, id: number) => {
                  setCompanyName(value);         // for dropdown display
                  setCompanyId(String(id));      // for logic
                  onDirtyChange(true);
                  setModifiedFields((prev) => ({ ...prev, companyId: true }));
                  setFormErrors((prev) => ({ ...prev, companyId: "" }));
                }}
                
                onFocus={() => setActiveField("companyId")}
                disabled={!isEditMode && isViewMode}
                className={`w-full p-1 mt-[-4px] border rounded-lg shadow-inner text-sm transition-all duration-200
                ${
                  !isEditMode
                    ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                    : activeField === "companyId" || modifiedFields.companyId
                    ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                }`}
              />
              {formErrors.companyId && (
                <p className="text-red-500 text-xs mt-1">{formErrors.companyId}</p>
              )}
            </div>

            {/*  Login Name */}
            <div>
            <label className="block text-gray-700 mb-2 font-medium">
          Client Name<span className="text-red-500 text-lg align-top ml-1">*</span>
        </label>

              <input
                type="text"
                value={loginName}
                onChange={(e) => {
                  setLoginName(e.target.value);
                  setFormErrors((prev) => ({ ...prev, loginName: "" }));
                  onDirtyChange(true);
                }}
                placeholder="Enter client name"
                onFocus={() => setActiveField("loginName")}
                disabled={!isEditMode && isViewMode}
                className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
                  !isEditMode
                    ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                    : activeField === "loginName" || modifiedFields.loginName
                    ? "border-green-500 focus:ring-2 focus:ring-green-500"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                }`}
              />
              {isCreateMode && loginName && (
                <p className="text-sm text-gray-500 mt-1">
                  Full name: BETMExternal-API-{loginName}{environment !== "PROD" ? `-${environment}` : ""}
                </p>
              )}
              {formErrors.loginName && (
                <p className="text-red-500 text-xs mt-1">{formErrors.loginName}</p>
              )}
            </div>

            {!isCreateMode && (
              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Client ID
                </label>
                <input
                  type="text"
                  value={clientId}
                  readOnly
                  disabled
                  className="w-full p-3 border rounded-lg shadow-inner text-sm bg-[#f9f9f9] text-gray-800 border-gray-300"
                />
              </div>
            )}
          </div>

        )}

{entityType === "USER" && (
          <>
            {/* ROW 1 → Email + Company */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Email
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    onDirtyChange(true);
                    setModifiedFields((prev) => ({ ...prev, email: true }));
                    setFormErrors((prev) => ({ ...prev, email: "" }));
                  }}
                  onFocus={() => setActiveField("email")}
                  disabled={!isEditMode && isViewMode}
                  className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
                    !isEditMode
                      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                      : activeField === "email" || modifiedFields.email
                      ? "border-green-500 focus:ring-2 focus:ring-green-500"
                      : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                  }`}
                />
                {formErrors.email && (
                  <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Company
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>

                <CompanyDropdown
                  selectedCompany={companyName}
                  onCompanyChange={(value: string, id: number) => {
                    setCompanyName(value);
                    setCompanyId(String(id));
                    onDirtyChange(true);
                    setModifiedFields((prev) => ({ ...prev, companyId: true }));
                    setFormErrors((prev) => ({ ...prev, companyId: "" }));
                  }}
                  onFocus={() => setActiveField("companyId")}
                  disabled={!isEditMode && isViewMode}
                  className={`w-full p-1 mt-[-4px] border rounded-lg shadow-inner text-sm transition-all duration-200
                  ${
                    !isEditMode
                      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                      : activeField === "companyId" || modifiedFields.companyId
                      ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                      : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                  }`}
                />
                {formErrors.companyId && (
                  <p className="text-red-500 text-xs mt-1">{formErrors.companyId}</p>
                )}
              </div>
            </div>

            


            {/* ROW 2 → First Name + Last Name */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  First Name
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                    onDirtyChange(true);
                    setModifiedFields((prev) => ({ ...prev, firstName: true }));
                    setFormErrors((prev) => ({ ...prev, firstName: "" }));
                  }}
                  onFocus={() => setActiveField("firstName")}
                  disabled={!isEditMode && isViewMode}
                  className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
                    !isEditMode
                      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                      : activeField === "firstName" || modifiedFields.firstName
                      ? "border-green-500 focus:ring-2 focus:ring-green-500"
                      : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                  }`}
                />
                {formErrors.firstName && (
                  <p className="text-red-500 text-xs mt-1">{formErrors.firstName}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Last Name
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                    onDirtyChange(true);
                    setModifiedFields((prev) => ({ ...prev, lastName: true }));
                    setFormErrors((prev) => ({ ...prev, lastName: "" }));
                  }}
                  onFocus={() => setActiveField("lastName")}
                  disabled={!isEditMode && isViewMode}
                  className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
                    !isEditMode
                      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                      : activeField === "lastName" || modifiedFields.lastName
                      ? "border-green-500 focus:ring-2 focus:ring-green-500"
                      : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                  }`}
                />
                {formErrors.lastName && (
                  <p className="text-red-500 text-xs mt-1">{formErrors.lastName}</p>
                )}
              </div>
            </div>

            {/* <div className="grid grid-cols-4 gap-6">

            <div className="col-span-1">
              <label className="block text-gray-700 mb-2 font-medium">
                First Name
                <span className="text-red-500 text-lg align-top ml-1">*</span>
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  onDirtyChange(true);
                }}
                onFocus={() => setActiveField("firstName")}
                disabled={!isEditMode && isViewMode}
                className="w-full p-3 border rounded-lg shadow-inner text-sm"
              />
            </div>

            <div className="col-span-1">
              <label className="block text-gray-700 mb-2 font-medium">
                Last Name
                <span className="text-red-500 text-lg align-top ml-1">*</span>
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  onDirtyChange(true);
                }}
                onFocus={() => setActiveField("lastName")}
                disabled={!isEditMode && isViewMode}
                className="w-full p-3 border rounded-lg shadow-inner text-sm"
              />
            </div>

            <div className="col-span-2">
              <label className="block text-gray-700 mb-2 font-medium">
                Email
                <span className="text-red-500 text-lg align-top ml-1">*</span>
              </label>
              <input
                type="text"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  onDirtyChange(true);
                }}
                onFocus={() => setActiveField("email")}
                disabled={!isEditMode && isViewMode}
                className="w-full p-3 border rounded-lg shadow-inner text-sm"
              />
            </div>

            </div> */}


            {/* ROW 3 → Email + Enabled */}
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Email
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    onDirtyChange(true);
                    setModifiedFields((prev) => ({ ...prev, email: true }));
                  }}
                  onFocus={() => setActiveField("email")}
                  disabled={!isEditMode && isViewMode}
                  className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200 ${
                    !isEditMode
                      ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                      : activeField === "email" || modifiedFields.email
                      ? "border-green-500 focus:ring-2 focus:ring-green-500"
                      : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                  }`}
                />
              </div>

              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Enabled
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>

                <EnabledDropdown
                  selectedEnabled={enabled}
                  onEnabledChange={(value) => {
                    setEnabled(value);
                    onDirtyChange(true);
                    setModifiedFields((prev) => ({ ...prev, enabled: true }));
                  }}
                  onFocus={() => setActiveField("enabled")}
                  disabled={!isEditMode && isViewMode}
                  className={`w-full p-1 mt-[-4px] border rounded-lg shadow-inner text-sm transition-all duration-200
                    ${
                      !isEditMode
                        ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                        : activeField === "enabled" || modifiedFields.enabled
                        ? "border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                        : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
                    }`}
                />
              </div>
            </div> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

            {/* Entra Object ID (only for EXISTING users) */}
            {/* {userCreationMode === "EXISTING" && (
              <div>
                <label className="block text-gray-700 mb-2 font-medium">
                  Entra Object ID
                  <span className="text-red-500 text-lg align-top ml-1">*</span>
                </label>

                <input
                  type="text"
                  value={entraObjectId}
                  onChange={(e) => {
                    setEntraObjectId(e.target.value);
                    onDirtyChange(true);
                  }}
                  disabled={!isEditMode && isViewMode}
                  className="w-full p-3 border rounded-lg shadow-inner text-sm"
                />
              </div>
            )} */}

            {/* Enabled */}
            <div>
              <label className="block text-gray-700 mb-2 font-medium">
                Enabled
                <span className="text-red-500 text-lg align-top ml-1">*</span>
              </label>

              <EnabledDropdown
                selectedEnabled={enabled}
                onEnabledChange={(value) => {
                  setEnabled(value);
                  onDirtyChange(true);
                }}
                disabled={!isEditMode && isViewMode}
                className="w-full p-1 mt-[-4px] border rounded-lg shadow-inner text-sm"
              />
            </div>

            </div>

          </>
        )}

        {(entityType === "USER" || entityType === "SERVICE_PRINCIPAL") && (
          <>
            <div>
          <label className="block text-gray-700 mb-2 font-medium">
            Roles
          </label>

          <RolesSelector
            roles={roles}
            selectedRoles={selectedRoles}
            preserveItemOrder={false}
            reorderSelectedOnOutside={true}
            onSelectionChange={(roles: number[]) => {
              onRolesChange(roles);
              onDirtyChange(true);
            }}
            disabled={!isEditMode && isViewMode}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">

          {/* Assets */}
          <div className="space-y-2">
            <label className="block text-gray-600 font-medium">
              Assets
            </label>
            <div className="bg-[#f9f9f9] p-3 border rounded-lg shadow-inner text-sm text-gray-700 max-h-40 overflow-y-auto">
              {assetsForUser.length > 0 ? (
                <ul className="list-disc pl-5">
                  {assetsForUser.map((asset, index) => (
                    <li key={index}>{asset}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-500 italic">No assets found</p>
              )}
            </div>
          </div>

          {/* Folders */}
          <div className="space-y-2">
            <label className="block text-gray-600 font-medium">
              Folders
            </label>
            <div className="bg-[#f9f9f9] p-3 border rounded-lg shadow-inner text-sm text-gray-700 max-h-40 overflow-y-auto">
              {foldersForUser.length > 0 ? (
                <ul className="list-disc pl-5">
                  {foldersForUser.map((folder, index) => (
                    <li key={index}>{folder}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-500 italic">No folders found</p>
              )}
            </div>
          </div>

        </div>
          </>
        )}


        {/*  Secret Display */}
        {entityType === "SERVICE_PRINCIPAL" && clientSecret && (
          <div className="mt-10">
            <label className="block text-gray-700 mb-2 font-medium">
              Client Secret
            </label>

            <div className="flex items-center gap-3">
              <input
                type="text"
                value={clientSecret}
                readOnly
                className="w-full p-3 border rounded-lg bg-gray-100 text-gray-800 font-mono"
              />

              <button
                type="button"
                onClick={handleCopySecret}
                className="px-4 py-2 bg-[#a6a9ac] text-white rounded-lg hover:bg-[#474747] transition-colors duration-300"
              >
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
          </div>
        )}


        {entityType === "SERVICE_PRINCIPAL" && isViewMode && entraObjectId && (
          <div className="mt-12 pt-8 border-t border-gray-200 flex items-center gap-4">
            <button
              type="button"
              onClick={handleGenerateSecret}
              className="px-6 py-3 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
            >
              Generate Secret
            </button>
            <button
              type="button"
              onClick={handleRevoke}
              className="px-6 py-3 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600 transition-colors duration-300"
            >
              Revoke Access
            </button>
          </div>
        )}


      </form>
    </div>
  );
};

export default UsersForm;
